import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Form,
  Row,
  Tab,
  Nav,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../Common/extra/loading";
import { checkValidations } from "../../../Services/Helper";
import {
  getFieldData,
  getFinanceById,
  postFinancial,
} from "../../../store/actions";
import Assets from "./financialComponents/Assets";
import EmploymentInfo from "./financialComponents/empInfo";
import IncomeExpenseStatement from "./financialComponents/incomeExpense";
import OtherFinancialInfo from "./financialComponents/otherFinancialInfo";
import PersonalAssets from "./financialComponents/personalAssets";
import PersonalInfo from "./financialComponents/personalInfo";
import RealPropertyOwned from "./financialComponents/realPropertyOwned";
import Vehicles from "./financialComponents/vehicles";
import { toast } from "react-toastify";
import { useSelect } from "@mui/base";
import LeagalInfo from "./financialComponents/Leagal";
import BankruptcyInfo from "./financialComponents/Bankruptcy";

const FinancialForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId } = useParams();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("incomeExpenseStatement");
  const [isComplete, setIsComplete] = useState({
    personalInfo: true,
    legal: true,
    bankruptcy: true,
    empInfo: true,
    otherFinanceInfo: true,
    personalAssets: true,
    realPropertyOwned: true,
    vehicles: true,
    assets: true,
    incomeExpense: true,
  });

  const [personalInfo, setPersonalInfo] = useState({
    full_name: "",
    marital_status: "",
    address: "",
    home_phone: "",
    cell_phone: "",
    work_phone: "",
    email: "",
    fax: "",
    social_security_no: "",
    date_of_birth: "",
    dependents: [{ name: "", age: "", relationship: "" }],
  });

  const [legalInfo, setLegalInfo] = useState({
    full_name: "",
    address: "",
    cell_phone: "",
    email: "",
  });

  const [bankruptcyInfo, setBankruptcyInfo] = useState({
    bank_name: "",
    account_number: "",
    amount: "",
    cell_phone: "",
    email: "",
    date_of_birth: "",
  });
  const [personalInfoErrors, setPersonalInfoError] = useState({
    full_name: "",
    marital_status: "",
    address: "",
    home_phone: "",
    cell_phone: "",
    work_phone: "",
    email: "",
    fax: "",
    social_security_no: "",
    date_of_birth: "",
    name: "",
    age: "",
    relationship: "",
  });
  const [legalInfoErrors, setLegalInfoError] = useState({
    full_name: "",
    address: "",
    cell_phone: "",
    email: "",
  });
  const [bankruptcyInfoErrors, setBankruptcyInfoError] = useState({
    bank_name: "",
    account_number: "",
    amount: "",
    cell_phone: "",
    email: "",
    date_of_birth: "",
  });

  const [employmentInfo, setEmploymentInfo] = useState({
    employer: "",
    length_of_job: "",
    employer_address: "",
    occupation: "",
    pay_period: "",

    spouse_employer: "",
    spouse_length_of_job: "",
    spouse_employer_address: "",
    spouse_occupation: "",
    spouse_pay_period: "",
  });

  const [employmentInfoError, setEmploymentInfoError] = useState({
    employer: "",
    length_of_job: "",
    employer_address: "",
    occupation: "",
    pay_period: "",

    spouse_employer: "",
    spouse_length_of_job: "",
    spouse_employer_address: "",
    spouse_occupation: "",
    spouse_pay_period: "",
  });
  const [otherFinanceInfo, setOtherFinanceInfo] = useState({
    are_you_currently_a_party_to_law_suit: "",
    plaintiff_defendent: "",
    location_of_filing: "",
    case_no: "",
    subject_of_suit: "",
    have_you_ever_filed_for_bankcrupty_protection: "",
    date_of_filing: "",
    date_of_discharge: "",
    petition_no: "",
    location: "",
    increase_decrease_in_income: "",
    beneficiary_to_any_trust_estate_life_insurance: "",
  });

  const [otherFinanceInfoError, setOtherFinanceInfoError] = useState({
    are_you_currently_a_party_to_law_suit: "",
    plaintiff_defendent: "",
    location_of_filing: "",
    case_no: "",
    subject_of_suit: "",
    have_you_ever_filed_for_bankcrupty_protection: "",
    date_of_filing: "",
    date_of_discharge: "",
    petition_no: "",
    location: "",
    increase_decrease_in_income: "",
    beneficiary_to_any_trust_estate_life_insurance: "",
  });

  const [personalAssets, setPersonalAssets] = useState({
    cash_on_hand: "",

    personal_fullname: "",
    personal_address_of_bank: "",
    personal_account_type: "",
    personal_account_number: "",
    personal_account_balance: "",

    additional_fullname: "",
    additional_address_of_bank: "",
    additional_account_type: "",
    additional_account_number: "",
    additional_account_balance: "",

    investment_type: "",
    investment_fullname: "",
    investment_address_of_institution: "",
    investment_account_number: "",
    investment_account_balance: "",

    whole_life_insurance: "",

    credit_fullname: "",
    credit_address_of_bank: "",
    credit_account_type: "",
    credit_account_number: "",
    credit_account_balance: "",
  });

  const [personalAssetsError, setPersonalAssetsError] = useState({
    cash_on_hand: "",

    personal_fullname: "",
    personal_address_of_bank: "",
    personal_account_type: "",
    personal_account_number: "",
    personal_account_balance: "",

    additional_fullname: "",
    additional_address_of_bank: "",
    additional_account_type: "",
    additional_account_number: "",
    additional_account_balance: "",

    investment_type: "",
    investment_fullname: "",
    investment_address_of_institution: "",
    investment_account_number: "",
    investment_account_balance: "",

    whole_life_insurance: "",

    credit_fullname: "",
    credit_address_of_bank: "",
    credit_account_type: "",
    credit_account_number: "",
    credit_account_balance: "",
  });

  const [realPropertyOwned, setRealPropertyOwned] = useState({
    property_description: "",
    location: "",
    current_fair_market_value: "",
    loan_balance: "",
    amount_of_monthly_payment: "",
    amount_of_your_equity: "",
    name_of_lender: "",
    address: "",
    account_no: "",
  });

  const [realPropertyOwnedError, setRealPropertyOwnedError] = useState({
    property_description: "",
    location: "",
    current_fair_market_value: "",
    loan_balance: "",
    amount_of_monthly_payment: "",
    amount_of_your_equity: "",
    name_of_lender: "",
    address: "",
    account_no: "",
  });

  const [vehicles, setVehicles] = useState({
    year: "",
    make: "",
    model: "",
    mileage: "",
    purchase_lease_date: "",
    cutrrent_market_value: "",
    amount_owned: "",
    monthly_payment: "",
    name: "",
    address: "",
    phone_of_lender_lessor: "",

    another_year: "",
    another_make: "",
    another_model: "",
    another_mileage: "",
    another_purchase_lease_date: "",
    another_cutrrent_market_value: "",
    another_amount_owned: "",
    another_monthly_payment: "",
    another_name: "",
    another_address: "",
    another_phone_of_lender_lessor: "",
  });

  const [vehiclesError, setVehiclesError] = useState({
    year: "",
    make: "",
    model: "",
    mileage: "",
    purchase_lease_date: "",
    cutrrent_market_value: "",
    amount_owned: "",
    monthly_payment: "",
    name: "",
    address: "",
    phone_of_lender_lessor: "",

    another_year: "",
    another_make: "",
    another_model: "",
    another_mileage: "",
    another_purchase_lease_date: "",
    another_cutrrent_market_value: "",
    another_amount_owned: "",
    another_monthly_payment: "",
    another_name: "",
    another_address: "",
    another_phone_of_lender_lessor: "",
  });

  const [assets, setAssets] = useState({
    furniture_location: "",
    furniture_value: "",
    furniture_loanbalance: "",

    personal_location: "",
    personal_value: "",
    personal_loanbalance: "",

    artwork_location: "",
    artwork_value: "",
    artwork_loanbalance: "",

    jewellery_location: "",
    jewellery_value: "",
    jewellery_loanbalance: "",

    collection_location: "",
    collection_value: "",
    collection_loanbalance: "",

    guns_location: "",
    guns_value: "",
    guns_loanbalance: "",

    coins_location: "",
    coins_value: "",
    coins_loanbalance: "",

    antiques_location: "",
    antiques_value: "",
    antiques_loanbalance: "",
  });

  const [assetsError, setAssetsError] = useState({
    furniture_location: "",
    furniture_value: "",
    furniture_loanbalance: "",

    personal_location: "",
    personal_value: "",
    personal_loanbalance: "",

    artwork_location: "",
    artwork_value: "",
    artwork_loanbalance: "",

    jewellery_location: "",
    jewellery_value: "",
    jewellery_loanbalance: "",

    collection_location: "",
    collection_value: "",
    collection_loanbalance: "",

    guns_location: "",
    guns_value: "",
    guns_loanbalance: "",

    coins_location: "",
    coins_value: "",
    coins_loanbalance: "",

    antiques_location: "",
    antiques_value: "",
    antiques_loanbalance: "",
  });

  const [incomeExpenseState, setIncomeExpenseState] = useState({
    gross_you: "0",
    gross_spouse_partner: "0",

    rent_you: "0",
    rent_spouse_partner: "0",

    other_you: "0",
    other_spouse_partner: "0",

    child_you: "0",
    child_spouse_partner: "0",

    soc_you: "0",
    soc_spouse_partner: "0",

    pension_you: "0",
    pension_spouse_partner: "0",

    misc_you: "0",
    misc_spouse_partner: "0",

    primary_home_mortgage: "0",
    primary_home_tax_ins: "0",
    any_other_mortgage: "0",
    any_other_property_tax_ins: "0",
    credit_card_payments_total: "0",
    any_other_revolving_debt: "0",
    installment_loan_payments: "0",
    dependent_child_care: "0",

    personal_loans: "0",
    income_tax_from_paycheck: "0",
    fourZeroOneKLoans: "0",
    child_support: "0",
    alimony: "0",
    irs_liens: "0",
    tuition: "0",

    student_loans: "0",
    gas: "0",
    electric: "0",
    water: "0",
    trash_sewer: "0",
    telephone: "0",
    cell_phone: "0",
    internet: "0",
    cable_satellite: "0",
    vehicle_insurance: "0",
    maintenance: "0",
    food: "0",
    transportation: "0",
    gardening_landscaping: "0",
    housecleaning: "0",
    other: "0",

    insurance_medical_amount: "0",
    insurance_medical_paycheck: "0",

    insurance_dental_amount: "0",
    insurance_dental_paycheck: "0",

    insurance_life_amount: "0",
    insurance_life_paycheck: "0",

    insurance_vision_amount: "0",
    insurance_vision_paycheck: "0",

    insurance_disability_amount: "0",
    insurance_disability_paycheck: "0",

    insurance_surrender_amount: "0",
    insurance_surrender_paycheck: "0",
  });

  const [dummyIncome, setDummyIncome] = useState({});

  const [dummyExpense, setDummyExpense] = useState({});

  const [incomeTotal, setIncomeTotal] = useState("0");
  const [expenseTotal, setExpenseTotal] = useState("0");
  const [netTotal, setNetTotal] = useState("0");
  console.log(
    "income total",
    incomeTotal,
    "expense total",
    expenseTotal,
    "netTotal",
    netTotal
  );

  useEffect(() => {
    if (incomeExpenseState) {
      setDummyIncome({
        gross_you: incomeExpenseState.gross_you,
        gross_spouse_partner: incomeExpenseState.gross_spouse_partner,
        rent_you: incomeExpenseState.rent_you,
        rent_spouse_partner: incomeExpenseState.rent_spouse_partner,
        other_you: incomeExpenseState.other_you,
        other_spouse_partner: incomeExpenseState.other_spouse_partner,
        child_you: incomeExpenseState.child_you,
        child_spouse_partner: incomeExpenseState.child_spouse_partner,
        soc_you: incomeExpenseState.soc_you,
        soc_spouse_partner: incomeExpenseState.soc_spouse_partner,
        pension_you: incomeExpenseState.pension_you,
        pension_spouse_partner: incomeExpenseState.pension_spouse_partner,
        misc_you: incomeExpenseState.misc_you,
        misc_spouse_partner: incomeExpenseState.misc_spouse_partner,
      });
      setDummyExpense({
        primary_home_mortgage: incomeExpenseState.primary_home_mortgage,
        primary_home_tax_ins: incomeExpenseState.primary_home_tax_ins,
        any_other_mortgage: incomeExpenseState.any_other_mortgage,
        any_other_property_tax_ins:
          incomeExpenseState.any_other_property_tax_ins,
        credit_card_payments_total:
          incomeExpenseState.credit_card_payments_total,
        any_other_revolving_debt: incomeExpenseState.any_other_revolving_debt,
        installment_loan_payments: incomeExpenseState.installment_loan_payments,
        dependent_child_care: incomeExpenseState.dependent_child_care,
        personal_loans: incomeExpenseState.personal_loans,
        income_tax_from_paycheck: incomeExpenseState.income_tax_from_paycheck,
        fourZeroOneKLoans: incomeExpenseState.fourZeroOneKLoans,
        child_support: incomeExpenseState.child_support,
        alimony: incomeExpenseState.alimony,
        irs_liens: incomeExpenseState.irs_liens,
        tuition: incomeExpenseState.tuition,
        student_loans: incomeExpenseState.student_loans,
        gas: incomeExpenseState.gas,
        electric: incomeExpenseState.electric,
        water: incomeExpenseState.water,
        trash_sewer: incomeExpenseState.trash_sewer,
        telephone: incomeExpenseState.telephone,
        cell_phone: incomeExpenseState.cell_phone,
        internet: incomeExpenseState.internet,
        cable_satellite: incomeExpenseState.cable_satellite,
        vehicle_insurance: incomeExpenseState.vehicle_insurance,
        maintenance: incomeExpenseState.maintenance,
        food: incomeExpenseState.food,
        transportation: incomeExpenseState.transportation,
        gardening_landscaping: incomeExpenseState.gardening_landscaping,
        housecleaning: incomeExpenseState.housecleaning,
        other: incomeExpenseState.other,
        insurance_medical_amount: incomeExpenseState.insurance_medical_amount,
        insurance_medical_paycheck:
          incomeExpenseState.insurance_medical_paycheck,
        insurance_dental_amount: incomeExpenseState.insurance_dental_amount,
        insurance_dental_paycheck: incomeExpenseState.insurance_dental_paycheck,
        insurance_life_amount: incomeExpenseState.insurance_life_amount,
        insurance_life_paycheck: incomeExpenseState.insurance_life_paycheck,
        insurance_vision_amount: incomeExpenseState.insurance_vision_amount,
        insurance_vision_paycheck: incomeExpenseState.insurance_vision_paycheck,
        insurance_disability_amount:
          incomeExpenseState.insurance_disability_amount,
        insurance_disability_paycheck:
          incomeExpenseState.insurance_disability_paycheck,
        insurance_surrender_amount:
          incomeExpenseState.insurance_surrender_amount,
        insurance_surrender_paycheck:
          incomeExpenseState.insurance_surrender_paycheck,
      });
    }
  }, [incomeExpenseState]);

  useEffect(() => {
    if (dummyExpense && dummyIncome) {
      let totalExp = 0;
      let totalInc = 0;

      for (const key in dummyExpense) {
        if (dummyExpense.hasOwnProperty(key)) {
          // Parse the value to an integer (assuming they are strings)
          const value = parseInt(dummyExpense[key], 10) || 0;
          totalExp += value;
        }
      }

      for (const key in dummyIncome) {
        if (dummyIncome.hasOwnProperty(key)) {
          // Parse the value to an integer (assuming they are strings)
          const value = parseInt(dummyIncome[key], 10) || 0;
          totalInc += value;
        }
      }

      setIncomeTotal(totalInc);
      setExpenseTotal(totalExp);
      setNetTotal(totalInc - totalExp);
    }
  }, [dummyExpense, dummyIncome]);

  const [incomeExpenseStateError, setIncomeExpenseStateError] = useState({
    gross_you: "",
    gross_spouse_partner: "",

    rent_you: "",
    rent_spouse_partner: "",

    other_you: "",
    other_spouse_partner: "",

    child_you: "",
    child_spouse_partner: "",

    soc_you: "",
    soc_spouse_partner: "",

    pension_you: "",
    pension_spouse_partner: "",

    misc_you: "",
    misc_spouse_partner: "",

    primary_home_mortgage: "",
    primary_home_tax_ins: "",
    any_other_mortgage: "",
    any_other_property_tax_ins: "",
    credit_card_payments_total: "",
    any_other_revolving_debt: "",
    installment_loan_payments: "",
    dependent_child_care: "",
    personal_loans: "",
    income_tax_from_paycheck: "",
    fourZeroOneKLoans: "",
    child_support: "",
    alimony: "",
    irs_liens: "",
    tuition: "",
    student_loans: "",
    gas: "",
    electric: "",
    water: "",
    trash_sewer: "",
    telephone: "",
    cell_phone: "",
    internet: "",
    cable_satellite: "",
    vehicle_insurance: "",
    maintenance: "",
    food: "",
    transportation: "",
    gardening_landscaping: "",
    housecleaning: "",
    other: "",

    insurance_medical_amount: "",
    insurance_medical_paycheck: "",

    insurance_dental_amount: "",
    insurance_dental_paycheck: "",

    insurance_life_amount: "",
    insurance_life_paycheck: "",

    insurance_vision_amount: "",
    insurance_vision_paycheck: "",

    insurance_disability_amount: "",
    insurance_disability_paycheck: "",
  });

  const allData = useSelector((s) => s?.Signatures?.finance?.data);
  const FieldData = useSelector(
    (s) => s?.Signatures?.getFieldData?.field_data?.option_value
  );

  useEffect(() => {
    personalInfo &&
      FieldData &&
      FieldData?.personal_information_fields &&
      FieldData?.personal_information_fields.length > 0 &&
      FieldData?.personal_information_fields.map((item) => {
        return (
          !personalInfo[item?.title.toLowerCase().split(" ").join("_")] &&
          setPersonalInfo((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    legalInfo &&
      FieldData &&
      FieldData?.legal_fields &&
      FieldData?.legal_fields.length > 0 &&
      FieldData?.legal_fields.map((item) => {
        return (
          !legalInfo[item?.title.toLowerCase().split(" ").join("_")] &&
          setLegalInfo((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    bankruptcyInfo &&
      FieldData &&
      FieldData?.bankruptcy_field &&
      FieldData?.bankruptcy_field.length > 0 &&
      FieldData?.bankruptcy_field.map((item) => {
        return (
          !bankruptcyInfo[item?.title.toLowerCase().split(" ").join("_")] &&
          setBankruptcyInfo((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    employmentInfo &&
      FieldData &&
      FieldData?.employment_information_fields &&
      FieldData?.employment_information_fields.length > 0 &&
      FieldData?.employment_information_fields.map((item) => {
        return (
          !employmentInfo[item?.title.toLowerCase().split(" ").join("_")] &&
          setEmploymentInfo((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    otherFinanceInfo &&
      FieldData &&
      FieldData?.other_finanical_information_fields &&
      FieldData?.other_finanical_information_fields.length > 0 &&
      FieldData?.other_finanical_information_fields.map((item) => {
        return (
          !otherFinanceInfo[item?.title.toLowerCase().split(" ").join("_")] &&
          setOtherFinanceInfo((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    personalAssets &&
      FieldData &&
      FieldData?.personal_assets_fields &&
      FieldData?.personal_assets_fields.length > 0 &&
      FieldData?.personal_assets_fields.map((item) => {
        return (
          !personalAssets[item?.title.toLowerCase().split(" ").join("_")] &&
          setPersonalAssets((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    realPropertyOwned &&
      FieldData &&
      FieldData?.real_property_owned_fields &&
      FieldData?.real_property_owned_fields.length > 0 &&
      FieldData?.real_property_owned_fields.map((item) => {
        return (
          !realPropertyOwned[item?.title.toLowerCase().split(" ").join("_")] &&
          setRealPropertyOwned((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    vehicles &&
      FieldData &&
      FieldData?.vehicles_fields &&
      FieldData?.vehicles_fields.length > 0 &&
      FieldData?.vehicles_fields.map((item) => {
        return (
          !vehicles[item?.title.toLowerCase().split(" ").join("_")] &&
          setVehicles((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    assets &&
      FieldData &&
      FieldData?.assets_fields &&
      FieldData?.assets_fields.length > 0 &&
      FieldData?.assets_fields.map((item) => {
        return (
          !assets[item?.title.toLowerCase().split(" ").join("_")] &&
          setAssets((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });

    incomeExpenseState &&
      FieldData &&
      FieldData?.income_fields &&
      FieldData?.income_fields.length > 0 &&
      FieldData?.income_fields.map((item) => {
        return (
          !incomeExpenseState[item?.title.toLowerCase().split(" ").join("_")] &&
          setIncomeExpenseState((pre) => ({
            ...pre,
            [item?.title.toLowerCase().split(" ").join("_")]: "",
          }))
        );
      });
  }, [FieldData, allData]);

  useEffect(() => {
    const personalInfoVal = checkValidations(personalInfo);
    if (personalInfoVal.error) {
      setIsComplete((pre) => ({ ...pre, personalInfo: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, personalInfo: false }));
    }
  }, [personalInfo]);

  useEffect(() => {
    const empInfoVal = checkValidations(employmentInfo);
    if (empInfoVal.error) {
      setIsComplete((pre) => ({ ...pre, empInfo: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, empInfo: false }));
    }
  }, [employmentInfo]);

  useEffect(() => {
    const otherFinInfo = checkValidations(otherFinanceInfo);
    if (otherFinInfo.error) {
      setIsComplete((pre) => ({ ...pre, otherFinanceInfo: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, otherFinanceInfo: false }));
    }
  }, [otherFinanceInfo]);

  useEffect(() => {
    const personalAssetsVal = checkValidations(personalAssets);
    if (personalAssetsVal.error) {
      setIsComplete((pre) => ({ ...pre, personalAssets: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, personalAssets: false }));
    }
  }, [personalAssets]);

  useEffect(() => {
    const realpropertyVal = checkValidations(realPropertyOwned);
    if (realpropertyVal.error) {
      setIsComplete((pre) => ({ ...pre, realPropertyOwned: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, realPropertyOwned: false }));
    }
  }, [realPropertyOwned]);

  useEffect(() => {
    const vehiclesVal = checkValidations(vehicles);
    if (vehiclesVal.error) {
      setIsComplete((pre) => ({ ...pre, vehicles: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, vehicles: false }));
    }
  }, [vehicles]);

  useEffect(() => {
    const assetsVal = checkValidations(assets);
    if (assetsVal.error) {
      setIsComplete((pre) => ({ ...pre, assets: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, assets: false }));
    }
  }, [assets]);

  useEffect(() => {
    const incomeVal = checkValidations(incomeExpenseState);
    if (incomeVal.error) {
      setIsComplete((pre) => ({ ...pre, incomeExpense: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, incomeExpense: false }));
    }
  }, [incomeExpenseState]);

  useEffect(() => {
    const legalVal = checkValidations(legalInfo);
    if (legalVal.error) {
      setIsComplete((pre) => ({ ...pre, legal: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, legal: false }));
    }
  }, [legalInfo]);

  useEffect(() => {
    const bankruptcyVal = checkValidations(bankruptcyInfo);
    if (bankruptcyVal.error) {
      setIsComplete((pre) => ({ ...pre, bankruptcy: true }));
    } else {
      setIsComplete((pre) => ({ ...pre, bankruptcy: false }));
    }
  }, [bankruptcyInfo]);

  useEffect(() => {
    if (editId && allData) {
      setPersonalInfo({
        ...allData?.personal_information,
        dependents: (allData?.personal_information &&
          allData?.personal_information.dependents) || [
          { name: "", age: "", relationship: "" },
        ],
      });
      setLegalInfo(allData?.legal_fields);
      setBankruptcyInfo(allData?.bankruptcy_field && allData?.bankruptcy_field);
      setEmploymentInfo(allData?.employment_information);
      setOtherFinanceInfo(allData?.other_finanical_information);
      setPersonalAssets(allData?.personal_assets);
      setRealPropertyOwned(allData?.real_property_owned);
      setVehicles(allData?.vehicles);
      setAssets(allData?.assets);
      setIncomeExpenseState(allData?.income);
    }
  }, [allData, editId]);

  useEffect(() => {
    if (editId) {
      dispatch(getFinanceById(editId));
    }
    dispatch(getFieldData());
  }, [editId]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleSaveField = async (addonData) => {
    await setPersonalInfo((pre) => ({ ...pre, dependents: addonData }));
    let body = {
      personal_information: personalInfo,
      bankruptcy_field: bankruptcyInfo,
      legal_fields: legalInfo,
      employment_information: employmentInfo,
      other_finanical_information: otherFinanceInfo,
      personal_assets: personalAssets,
      real_property_owned: realPropertyOwned,
      vehicles: vehicles,
      another_vehicle_description: {},
      assets: assets,
      income: incomeExpenseState,
      expenses: {},
      expenses_insurance: {},
    };
    dispatch(postFinancial({ user_id: Number(editId), ...body }, editId));
  };

  const handleSubmitBlur = () => {
    let body = {
      personal_information: personalInfo,
      bankruptcy_field: bankruptcyInfo,
      legal_fields: legalInfo,
      employment_information: employmentInfo,
      other_finanical_information: otherFinanceInfo,
      personal_assets: personalAssets,
      real_property_owned: realPropertyOwned,
      vehicles: vehicles,
      another_vehicle_description: {},
      assets: assets,
      income: incomeExpenseState,
      expenses: {},
      expenses_insurance: {},
    };
    dispatch(postFinancial({ user_id: Number(editId), ...body }, editId));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();

    const callBack = (res) => {
      if (res.data) {
        toast.success("Form Submitted Successfully!");
        navigate("/client/financial-form");
        setActiveTab("personalInfo");
      }
    };
    let body = {
      personal_information: personalInfo,
      legal_fields: legalInfo,
      bankruptcy_fields: bankruptcyInfo,
      employment_information: employmentInfo,
      other_finanical_information: otherFinanceInfo,
      personal_assets: personalAssets,
      real_property_owned: realPropertyOwned,
      vehicles: vehicles,
      another_vehicle_description: {},
      assets: assets,
      income: incomeExpenseState,
      expenses: {},
      expenses_insurance: {},
    };
    dispatch(
      postFinancial({ user_id: Number(editId), ...body }, editId, callBack)
    );
  };

  const handleBackBtn = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2 d-flex justify-content-between">
              <div className="top mb-2 left">
                <Breadcrumb>
                  <Breadcrumb.Item>Financial Questionaire</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="d-flex right gap-10">
                <Link
                  className="sm-button d-flex align-items-center justify-content-center"
                  to={`/customers/profile/${editId}`}
                >
                  Back to Profile
                </Link>
                {/* <Button className="sm-button">Client Info - Caller</Button> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container id="left-tabs-example">
                <Nav
                  variant="pills"
                  className="bg-white mb-3 commonTabs commonfinanceTabs viewprofile"
                >
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.incomeExpense ? "form-undone" : "form-done"
                      } ${activeTab == "incomeExpenseStatement" && "active"}`}
                      onClick={() => handleTabChange("incomeExpenseStatement")}
                    >
                      Income and Expense Statement
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.personalInfo ? "form-undone" : "form-done"
                      } ${activeTab == "personalInfo" && "active"}`}
                      onClick={() => handleTabChange("personalInfo")}
                    >
                      Personal Information
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.empInfo ? "form-undone" : "form-done"
                      } ${activeTab == "empInfo" && "active"}`}
                      onClick={() => handleTabChange("empInfo")}
                    >
                      Employment Information
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.otherFinanceInfo
                          ? "form-undone"
                          : "form-done"
                      } ${activeTab == "otherFinancialInfo" && "active"}`}
                      onClick={() => handleTabChange("otherFinancialInfo")}
                    >
                      Other Financial Information
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.personalAssets ? "form-undone" : "form-done"
                      } ${activeTab == "personalAssets" && "active"}`}
                      onClick={() => handleTabChange("personalAssets")}
                    >
                      Personal Assets
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.realPropertyOwned
                          ? "form-undone"
                          : "form-done"
                      } ${activeTab == "realPropertyOwned" && "active"}`}
                      onClick={() => handleTabChange("realPropertyOwned")}
                    >
                      Real Property Owned
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.vehicles ? "form-undone" : "form-done"
                      } ${activeTab == "vehicles" && "active"}`}
                      onClick={() => handleTabChange("vehicles")}
                    >
                      Vehicles
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.assets ? "form-undone" : "form-done"
                      } ${activeTab == "assets" && "active"}`}
                      onClick={() => handleTabChange("assets")}
                    >
                      Assets
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.legal ? "form-undone" : "form-done"
                      } ${activeTab == "legal" && "active"}`}
                      onClick={() => handleTabChange("legal")}
                    >
                      Legal
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      className={`bg-transparent border-0 py-3 position-relative px-3 ${
                        isComplete.bankruptcy ? "form-undone" : "form-done"
                      } ${activeTab == "bankruptcy" && "active"}`}
                      onClick={() => handleTabChange("bankruptcy")}
                    >
                      Bankruptcy
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane
                    className={activeTab == "personalInfo" ? "active show" : ""}
                  >
                    <PersonalInfo
                      personalInfo={personalInfo || {}}
                      setPersonalInfo={setPersonalInfo}
                      handleTabChange={handleTabChange}
                      errors={personalInfoErrors}
                      setError={setPersonalInfoError}
                      handleSubmitBlur={handleSubmitBlur}
                      extraFields={FieldData?.personal_information_fields}
                      handleSaveField={handleSaveField}
                    />
                  </Tab.Pane>

                  <Tab.Pane
                    className={activeTab == "legal" ? "active show" : ""}
                  >
                    <LeagalInfo
                      legalInfo={legalInfo || {}}
                      setLegalInfo={setLegalInfo}
                      handleTabChange={handleTabChange}
                      errors={legalInfoErrors}
                      setError={setLegalInfoError}
                      handleSubmitBlur={handleSubmitBlur}
                      extraFields={FieldData?.legal_fields}
                      handleBackBtn={handleBackBtn}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={activeTab == "bankruptcy" ? "active show" : ""}
                  >
                    <BankruptcyInfo
                      bankruptcyInfo={bankruptcyInfo && bankruptcyInfo}
                      setBankruptcyInfo={setBankruptcyInfo}
                      extraFields={FieldData?.bankruptcy_fields}
                      setError={setBankruptcyInfoError}
                      errors={bankruptcyInfoErrors}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      handleSubmitForm={handleSubmitForm}
                    />
                  </Tab.Pane>

                  <Tab.Pane
                    className={activeTab == "empInfo" ? "active show" : ""}
                  >
                    <EmploymentInfo
                      employmentInfo={employmentInfo}
                      setEmploymentInfo={setEmploymentInfo}
                      errors={employmentInfoError}
                      setError={setEmploymentInfoError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      extraFields={FieldData?.employment_information_fields}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={
                      activeTab == "otherFinancialInfo" ? "active show" : ""
                    }
                  >
                    <OtherFinancialInfo
                      otherFinanceInfo={otherFinanceInfo || {}}
                      setOtherFinanceInfo={setOtherFinanceInfo}
                      errors={otherFinanceInfoError}
                      setError={setOtherFinanceInfoError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      extraFields={
                        FieldData?.other_finanical_information_fields
                      }
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={
                      activeTab == "personalAssets" ? "active show" : ""
                    }
                  >
                    <PersonalAssets
                      personalAssets={personalAssets}
                      setPersonalAssets={setPersonalAssets}
                      errors={personalAssetsError}
                      setError={setPersonalAssetsError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      extraFields={FieldData?.personal_assets_fields}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={
                      activeTab == "realPropertyOwned" ? "active show" : ""
                    }
                  >
                    <RealPropertyOwned
                      realPropertyOwned={realPropertyOwned}
                      setRealPropertyOwned={setRealPropertyOwned}
                      errors={realPropertyOwnedError}
                      setError={setRealPropertyOwnedError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      extraFields={FieldData?.real_property_owned_fields}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={activeTab == "vehicles" ? "active show" : ""}
                  >
                    <Vehicles
                      vehicles={vehicles}
                      setVehicles={setVehicles}
                      errors={vehiclesError}
                      setError={setVehiclesError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      extraFields={FieldData?.vehicles_fields}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={
                      activeTab == "incomeExpenseStatement" ? "active show" : ""
                    }
                  >
                    <IncomeExpenseStatement
                      incomeExpenseState={incomeExpenseState}
                      setIncomeExpenseState={setIncomeExpenseState}
                      errors={incomeExpenseStateError}
                      setError={setIncomeExpenseStateError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      handleSubmitForm={handleSubmitForm}
                      extraFields={FieldData?.income_fields}
                      incomeTotal={incomeTotal}
                      expenseTotal={expenseTotal}
                      netTotal={netTotal}
                    />
                  </Tab.Pane>
                  <Tab.Pane
                    className={activeTab == "assets" ? "active show" : ""}
                  >
                    <Assets
                      assets={assets}
                      setAssets={setAssets}
                      errors={assetsError}
                      setError={setAssetsError}
                      handleTabChange={handleTabChange}
                      handleSubmitBlur={handleSubmitBlur}
                      handleBackBtn={handleBackBtn}
                      extraFields={FieldData?.assets_fields}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FinancialForm;
